export default "__VITE_ASSET__DFt7ttI8__"